// CustomerSelectionModal.js
import React, { useState, useEffect, useContext, useRef } from 'react';
import 'datatables.net-bs5';
import $ from 'jquery';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import Draggable from 'react-draggable';
import Swal from 'sweetalert2';

import StockDiscountCategoryService from "../../../Parts/Controller/StockDiscountCategoryController";
import CustomerDiscountService from "../../../Customer/Controller/CustomerDiscountController";
import { useNavigate } from 'react-router-dom';
import CreateStock from "./CreateStock";
import { Link } from "react-router-dom";
import CustomerService from "../../../Customer/Controller/CustomerController";
import { handleSubmit as CustomerDiscountSubmit } from "../../../Customer/Controller/CreateCustomerDiscountController";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
import PartService from '../../../Parts/Controller/PartController';
function CustomerSelectionModal({ show, onClose, CategoryID }) {
    const navigate = useNavigate();
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const [errors, setErrors] = useState({});
    const [stockList, setStockList] = useState([]);
    const [currentCustomer, setCurrentCustomer] = useState(null);
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
    const [AllCustomerList, setCustomerData] = useState([]);
    const [stockCategoryList, setStockCategories] = useState([]);
    const [DiscountsList, setDiscounts] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [currentStoc, setCurrentStoc] = useState(null);
    const [isStockModalOpen, setIsStockModalOpen] = useState(false);
    const [partList, setPartData] = useState([]);
    const [specialPrices, setSpecialPrices] = useState({});
    const tableRef = useRef();
    const fetchStocks = async (CategoryID) => {
        try {
            const data = await StockDiscountCategoryService.GetAllStockByCategoryID(CategoryID)
            setStockList(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    useEffect(() => {
        fetchStocks(CategoryID);
        fetchDiscount();
        fetchParts(CategoryID);

    }, [CategoryID]);
    const fetchParts = async (CategoryID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            debugger;
            const data = await StockDiscountCategoryService.GetAllPartsForDiscountCategory(CategoryID,redirectCallback);
            setPartData(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const truncateText = (text, maxLength = 15) => {
        if (!text) return '';
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const fetchCustomerList = async () => {
        try {
            const customerData = await CustomerService.GetAllCustomers();
            setCustomerData(customerData);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const handleDeleteCustomerClick = async (ID) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await CustomerDiscountService.DeleteCustomerDiscount(ID, redirectCallback);
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );


                } catch (error) {
                    console.error('Error deleting Contact:', error);
                }
            }
        })
    };
    const handleCloseStockModal = () => {
        setIsStockModalOpen(false);
    };
    const handleCreateStockClick = (stock) => {
        setCurrentStoc(null);
        setIsStockModalOpen(true);
    };
    const handlePartSelect = async (event, parts, CategoryID) => {

        try {

            for (const part of parts) {

                const formData = {
                    ID: 0,
                    FK_Stock_ID: part.PK_Stock_ID,
                    FK_Stock_Category_ID: CategoryID,
                    SpecialPrice: part.SpecialPrice
                };

                await StockDiscountCategoryService.CreateStockDiscountCategory(
                    event,
                    formData
                );
            }

            Swal.fire(
                'Success!',
                'Selected parts assigned successfully.',
                'success'
            );


            fetchStocks(CategoryID);
            fetchParts(CategoryID);
            handleCloseStockModal();

        } catch (error) {

            Swal.fire(
                'Error!',
                'Failed to assign selected parts.',
                'error'
            );
        }
    };
    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const handleDeleteStockClick = async (ID) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await StockDiscountCategoryService.DeleteStockDiscountCategory(redirectCallback, ID);
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                    fetchStocks(CategoryID);
                    fetchParts(CategoryID);

                } catch (error) {
                    console.error('Error deleting stock discount:', error);
                }
            }
        });
    };
    const handleSpecialPriceChange = (partId, value) => {
        setSpecialPrices(prev => ({
            ...prev,
            [partId]: value
        }));
    };
    const handleSubmit = async (event) => {
        try {
            for (const stock of stockList) {
                const formData = {
                    ID: stock.ID, // Existing record ID
                    FK_Stock_ID: stock.PK_Stock_ID,
                    FK_Stock_Category_ID: CategoryID,
                    SpecialPrice:
                        specialPrices[stock.PK_Stock_ID] ??
                        (stock.SpecialPrice > 0
                            ? stock.SpecialPrice
                            : stock.mon_SalesPrice),
                };

                await StockDiscountCategoryService.CreateStockDiscountCategory(
                    event,
                    formData
                );
            }

            Swal.fire(
                "Success!",
                "Special prices updated successfully.",
                "success"
            );

            fetchStocks(CategoryID);
        } catch (error) {
            console.error(error);

            Swal.fire(
                "Error!",
                "Failed to update special prices.",
                "error"
            );
        }
    };
    return (
        <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none', "marginTop": "50px" }} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <Draggable handle=".modal-header" onStart={handleStart}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Assigned Parts</h5>
                            <button type="button" className="btn-close" onClick={onClose}></button>
                        </div>
                        <div className="modal-body">

                            <div style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "10px" }}>
                                <div className="col-xl-12">
                                    <Link className='btn btn-primary btn-sm' onClick={handleCreateStockClick}>
                                        <i className="icofont-plus" aria-hidden="true">Add New</i>
                                    </Link>
                                </div>
                            </div>

                            <div style={{ "marginLeft": "10px", "marginRight": "0px", "marginTop": "10px" }}>
                                <table className="table table-striped" ref={tableRef} style={{ "width": "100%" }}>
                                    <thead>
                                        <tr>
                                            <th className="no-wrap ellipsis">Product Code</th>
                                            <th className="no-wrap ellipsis">Description</th>
                                            <th className="no-wrap ellipsis">Sale Price</th>
                                            <th className="no-wrap ellipsis">Special Price</th>
                                            <th style={{ "textAlign": "right" }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stockList.map((stock, index) => (
                                            <tr key={stock.ID}>
                                                <td className="no-wrap ellipsis">{stock.vc_StockCode}</td>
                                                <td className="no-wrap ellipsis"> {truncateText(stock.vc_StockName, 15)}</td>
                                                <td className="no-wrap ellipsis">{stock.mon_SalesPrice}</td>
                                                <td style={{ width: '150px' }}>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        className="form-control form-control-sm"
                                                        value={
                                                            specialPrices[stock.PK_Stock_ID] ??
                                                            (
                                                                stock.SpecialPrice > 0
                                                                    ? stock.SpecialPrice
                                                                    : stock.mon_SalesPrice
                                                            )
                                                        }
                                                        onChange={(e) =>
                                                            handleSpecialPriceChange(
                                                                stock.PK_Stock_ID,
                                                                e.target.value
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td style={{ "textAlign": "right" }}>
                                                    <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleDeleteStockClick(stock.ID)}>
                                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleSubmit}
                            >
                                <i className="icofont-save" aria-hidden="true"> Save</i>
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={onClose}
                            >
                                <i className="icofont-close" aria-hidden="true"> Close</i>
                            </button>


                        </div>
                    </div>
                </Draggable>
                {isStockModalOpen && (
                    <CreateStock
                        show={isStockModalOpen}
                        onClose={handleCloseStockModal}
                        parts={partList}
                        onSelectPart={handlePartSelect}
                        stockCategoryList={stockCategoryList}
                        CategoryID={CategoryID}
                    />
                )}
            </div>

        </div>
    );
}

export default CustomerSelectionModal;
